<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-06-22 10:10:27
 * @LastEditors: shenlin
 * @LastEditTime: 2022-06-29 17:12:29
-->
<template>
  <div class="app-container">
    <div class="tab">
      <orderDetail></orderDetail>
      <reimbursement></reimbursement>
      <!-- <el-tabs
        style="font-size:18px;"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="订单详情" name="first"
          ><orderDetail></orderDetail
        ></el-tab-pane>
        <el-tab-pane label="兑现详情" name="second"
          ><reimbursement></reimbursement
        ></el-tab-pane>
      </el-tabs> -->
    </div>
  </div>
</template>

<script>
import orderDetail from './orderDetail'
import reimbursement from './reimbursement'
export default {
  data() {
    return {
      activeName: this.$route.query.name || 'first'
    }
  },
  components: {
    orderDetail,
    reimbursement
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  overflow: auto;
  .tab {
    margin-left: 20px;
    margin: 10px 20px 0;
  }
}
/deep/.el-tabs__item {
  font-size: 17px !important;
  cursor: pointer;
}
</style>
